import { render } from "./app-table-list.vue?vue&type=template&id=0b813f79"
import script from "./app-table-list.vue?vue&type=script&lang=js"
export * from "./app-table-list.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/table/app-table-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b813f79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b813f79', __exports__)) {
    console.log('reload')
    api.reload('0b813f79', __exports__)
  }
  
  module.hot.accept("./app-table-list.vue?vue&type=template&id=0b813f79", () => {
    console.log('re-render')
    api.rerender('0b813f79', render)
  })

}


export default __exports__